module.exports = __webpack_public_path__ + "static/media/menu-equipment-white.ffa80bd7.svg";